module.exports = __webpack_public_path__ + "img/DSC_0787.1320cb1d.jpeg";